import { render, staticRenderFns } from "./List.vue?vue&type=template&id=e876190a"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e876190a')) {
      api.createRecord('e876190a', component.options)
    } else {
      api.reload('e876190a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=e876190a", function () {
      api.rerender('e876190a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/teams/List.vue"
export default component.exports